import { seoFor } from "@/lib/i18n/keywordPools";
import { createFileRoute } from "@tanstack/react-router";
import Premium from "@/pages/Premium";
import { MainLayout } from "@/components/layout/MainLayout";

export const Route = createFileRoute("/premium")({
  head: () => ({
    meta: [
      { title: "Statlign Premium — Live Odds Alerts & Full Model Breakdowns" },
      { name: "keywords", content: seoFor({ topics: ["home", "nigeria"] }).meta },
      { name: "description", content: "Statlign passes: Weekly ₦2,500, Premium Monthly ₦6,500 or VIP Yearly ₦35,000 — full match analysis, live odds alerts and an ad-free experience for every match in your pass days." },
      { property: "og:title", content: "Statlign Premium — Live Odds Alerts & Full Model Breakdowns" },
      { property: "og:type", content: "website" },
      { property: "og:description", content: "Statlign passes: Weekly ₦2,500, Premium Monthly ₦6,500 or VIP Yearly ₦35,000 — full match analysis, live odds alerts and an ad-free experience for every match in your pass days." },
      { name: "twitter:title", content: "Statlign Premium — Live Odds Alerts & Full Model Breakdowns" },
      { name: "twitter:description", content: "Statlign passes: Weekly ₦2,500, Premium Monthly ₦6,500 or VIP Yearly ₦35,000 — full match analysis, live odds alerts and an ad-free experience for every match in your pass days." },
    ],
  }),
  component: () => (
    <MainLayout>
      <Premium />
    </MainLayout>
  ),
});
